import "./saudiNationalDay.css"
import { isSaudiNationalDay } from "../occasions";

export default function SaudiNationalDay() {
    const root = document.documentElement;
    if (isSaudiNationalDay) {

        root.style.setProperty('--color-dark-beige-80', "rgba(120, 138, 131, 0.8)");
        root.style.setProperty('--color-dark-beige', "#0e3425");
        root.style.setProperty('--color-light-beige', "#1c9162");
        root.style.setProperty('--color-light-beige-10', "#4b9d7d");
        root.style.setProperty('--color-dark-orange', "#074d31");
        root.style.setProperty('--color-light-orange', "#92c4b0");
        root.style.setProperty('--color-lighter-orange', "#45be8e");
        root.style.setProperty('--color-dark-gray', "#d9e8e2");
        root.style.setProperty('--color-med-gray', "#b2c9bf");
        root.style.setProperty('--color-light-gray', "#e8efec");
    }

}

export function SaudiNationalHeader() {
    return (
        <div className="decorationSA"></div>

    )

}
